"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReadyState = exports.PlayerStates = void 0;
var PlayerStates;
(function (PlayerStates) {
    PlayerStates[PlayerStates["INIT"] = 0] = "INIT";
    PlayerStates[PlayerStates["START"] = 1] = "START";
    PlayerStates[PlayerStates["LOAD"] = 2] = "LOAD";
    PlayerStates[PlayerStates["PLAY"] = 3] = "PLAY";
    PlayerStates[PlayerStates["PAUSE"] = 4] = "PAUSE";
    PlayerStates[PlayerStates["END"] = 5] = "END";
    PlayerStates[PlayerStates["SEEKING"] = 6] = "SEEKING";
    PlayerStates[PlayerStates["SEEKED"] = 7] = "SEEKED";
    PlayerStates[PlayerStates["ERROR"] = 8] = "ERROR";
})(PlayerStates = exports.PlayerStates || (exports.PlayerStates = {}));
var ReadyState;
(function (ReadyState) {
    ReadyState[ReadyState["HAVE_NOTHING"] = 0] = "HAVE_NOTHING";
    ReadyState[ReadyState["HAVE_METADATA"] = 1] = "HAVE_METADATA";
    ReadyState[ReadyState["HAVE_CURRENT_DATA"] = 2] = "HAVE_CURRENT_DATA";
    ReadyState[ReadyState["HAVE_FUTURE_DATA"] = 3] = "HAVE_FUTURE_DATA";
    ReadyState[ReadyState["HAVE_ENOUGH_DATA"] = 4] = "HAVE_ENOUGH_DATA";
})(ReadyState = exports.ReadyState || (exports.ReadyState = {}));
//# sourceMappingURL=PlayerStates.js.map